import { render, staticRenderFns } from "./policyDetails.vue?vue&type=template&id=6ce4839c&scoped=true&"
import script from "./policyDetails.vue?vue&type=script&lang=js&"
export * from "./policyDetails.vue?vue&type=script&lang=js&"
import style0 from "./policyDetails.vue?vue&type=style&index=0&id=6ce4839c&prod&lang=scss&scoped=true&"
import style1 from "./policyDetails.vue?vue&type=style&index=1&id=6ce4839c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4839c",
  null
  
)

export default component.exports